import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/pay/payTrade/page', Object.assign({}, options, { params }));

export const getPayTradeDetail = (params, options) =>
  request.get(
    '/api/v4ward/pay/payOrderPlace/payOrderDetail',
    Object.assign({}, options, { params })
  );

export const getDetail = (params, options) =>
  request.get('/api/v4ward/pay/payTrade/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/pay/payTrade/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/pay/payTrade/submit', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/pay/payTrade/submit', params, options);
